import React, { useState } from 'react';
import { FiLock } from 'react-icons/fi';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { useChangePassword } from '../../hooks/useChangePassword';
import { useNotification } from '../../contexts/NotificationContext';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ isOpen, onClose }) => {
  const { submit, loading, error, setError } = useChangePassword();
  const { showSuccess } = useNotification();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

  const handleClose = () => {
    setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    setError(null);
    onClose();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    if (form.newPassword.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres');
      return;
    }
    try {
      await submit(form);
      showSuccess('Contraseña actualizada exitosamente');
      handleClose();
    } catch {
      // error is handled by the hook
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Cambiar contraseña" titleIcon={<FiLock className="w-5 h-5 text-primary-600" />} size="sm">
      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        {error && (
          <div className="bg-danger-50 border border-danger-200 text-danger-700 text-sm rounded-lg p-3">{error}</div>
        )}
        <div>
          <label className="block text-xs font-medium text-content-secondary mb-1">Contraseña actual</label>
          <input type="password" value={form.currentPassword} onChange={(e) => setForm({ ...form, currentPassword: e.target.value })}
            className="input-base w-full" required />
        </div>
        <div>
          <label className="block text-xs font-medium text-content-secondary mb-1">Nueva contraseña</label>
          <input type="password" value={form.newPassword} onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
            className="input-base w-full" required minLength={6} />
        </div>
        <div>
          <label className="block text-xs font-medium text-content-secondary mb-1">Confirmar nueva contraseña</label>
          <input type="password" value={form.confirmPassword} onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
            className="input-base w-full" required minLength={6} />
        </div>
        <div className="flex justify-end gap-2 pt-4 border-t border-border">
          <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
          <Button variant="primary" type="submit" loading={loading}>Cambiar contraseña</Button>
        </div>
      </form>
    </Modal>
  );
};

export default ChangePasswordModal;
